var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEventNavIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m22.322 8.369-6.28-.915-2.808-5.689c-.503-1.014-1.96-1.027-2.468 0L7.96 7.454l-6.281.915C.552 8.532.1 9.919.917 10.715l4.544 4.425-1.075 6.251c-.193 1.13.998 1.976 1.995 1.448L12 19.887l5.619 2.952c.997.524 2.188-.318 1.995-1.448l-1.075-6.251 4.544-4.425c.817-.795.365-2.183-.761-2.346Zm-5.997 6.049 1.019 5.946L12 17.56l-5.344 2.805 1.02-5.946-4.326-4.21 5.976-.868L12 3.926l2.674 5.414 5.976.868-4.325 4.21Z",
    fill: "#4965A0"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEventNavIcon);
export default __webpack_public_path__ + "static/media/event-nav-icon.ba52d321cf312883945340224828e553.svg";
export { ForwardRef as ReactComponent };